/* Página de produto: galeria e variantes */
(() => {
  const pdp = document.querySelector('[data-gc-pdp]');
  if (!pdp) return;
  const $ = (s, r = pdp) => r.querySelector(s);
  const $$ = (s, r = pdp) => [...r.querySelectorAll(s)];

  // ---------- galeria ----------
  const trilho = $('.gc-gallery__main');
  const slides = $$('.gc-gallery__slide');
  const thumbs = $$('.gc-gallery__thumb');
  const dots = $$('.gc-gallery__dots span');
  const mostrar = (i, suave = true) => {
    i = Math.max(0, Math.min(slides.length - 1, i));
    trilho.scrollTo({ left: slides[i].offsetLeft - trilho.offsetLeft, behavior: suave ? 'smooth' : 'auto' });
    marcar(i);
  };
  const marcar = (i) => {
    thumbs.forEach((t, k) => t.classList.toggle('is-on', k === i));
    dots.forEach((t, k) => t.classList.toggle('is-on', k === i));
    const t = thumbs[i];
    if (t) t.parentElement.scrollTo({ left: t.offsetLeft - t.parentElement.offsetLeft - 40, behavior: 'smooth' });
  };
  thumbs.forEach((t, i) => t.addEventListener('click', () => mostrar(i)));
  let tScroll;
  trilho.addEventListener('scroll', () => {
    clearTimeout(tScroll);
    tScroll = setTimeout(() => marcar(Math.round(trilho.scrollLeft / trilho.clientWidth)), 80);
  });

  // ---------- variantes ----------
  const variantes = JSON.parse($('[data-gc-variants]').textContent);
  const opts = $$('.gc-opt');
  const escolhidos = () => opts.map((o) => $('.gc-opt__btn.is-on', o)?.dataset.val);
  const money = (c) => window.GC.money(c);
  function atualizar() {
    const sel = escolhidos();
    const v = variantes.find((x) => x.options.every((val, i) => val === sel[i]));
    if (!v) return;
    $('[data-gc-vid]').value = v.id;
    $('[data-gc-new]').textContent = money(v.price);
    const old = $('[data-gc-old]'), save = $('[data-gc-save]');
    if (v.compare_at_price > v.price) {
      old.hidden = false; old.textContent = money(v.compare_at_price);
      save.hidden = false; $('[data-gc-pct]').textContent = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
    } else { old.hidden = true; save.hidden = true; }
    const atc = $('[data-gc-atc]');
    atc.disabled = !v.available;
    atc.textContent = v.available ? 'Ajouter au panier' : 'Épuisé';
    if (v.featured_media) {
      const i = slides.findIndex((s) => +s.dataset.mediaId === v.featured_media.id);
      if (i >= 0) mostrar(i);
    }
    const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
  }
  opts.forEach((o) => o.addEventListener('click', (e) => {
    const b = e.target.closest('.gc-opt__btn');
    if (!b) return;
    $$('.gc-opt__btn', o).forEach((x) => x.classList.toggle('is-on', x === b));
    atualizar();
  }));
})();
